<template>
  <div>
    <Modal :title="`「${typeName}」包含模板管理`" v-model="show" width="800">
      <Spin fix v-if="dataGetting"></Spin>
      <Alert v-else-if="dataError" show-icon type="error">
        数据获取失败
        <a style="float: right" v-on:click="getTemplates">刷新</a>
      </Alert>
      <transfer
        v-else
        :data="templates"
        :target-keys="typeTemplates"
        :list-style="{
          width: '340px',
          height: '400px'
        }"
        :titles="['未选模板', '已选模板']"
        @on-change="templateTypeChange"
        filterable></transfer>
      <div slot="footer">
        <Button type="primary" @click="submit" :loading="submitting" :disabled="dataError">提交</Button>
        <Button @click="show = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getContainerTemplates, editContainerTemplateType } from '@/api/container/template'

export default {
  name: 'type-template',
  data () {
    return {
      typeId: '',
      typeName: '',
      typeTemplates: [],
      show: false,
      dataError: false,
      dataGetting: false,
      templates: [],
      submitting: false
    }
  },
  methods: {
    showModal (type) {
      this.typeId = type.id
      this.typeName = type.name
      this.typeTemplates = type.templates
      this.getTemplates()
      this.show = true
    },
    getTemplates () {
      this.dataGetting = true
      this.dataError = false
      this.templates = []
      getContainerTemplates().then(res => {
        this.data = res.data
        this.dataGetting = false
        for (let i in res.data) {
          this.templates.push({
            key: res.data[i].id,
            label: res.data[i].title
          })
        }
      }).catch(res => {
        this.dataGetting = false
        console.error(res.response)
        this.dataError = true
      })
    },
    templateTypeChange (newTargetKeys) {
      this.typeTemplates = newTargetKeys
    },
    submit () {
      let reqData = {
        templates: this.typeTemplates
      }
      this.submitting = true
      editContainerTemplateType(reqData, this.typeId).then(res => {
        this.$Notice.success({title: '操作成功'})
        this.show = false
        this.submitting = false
        this.$emit('callback')
      }).catch(res => {
        this.submitting = false
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
          console.error(res.response)
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
